import { SNACKBAR_DURATION_MS } from '../../shared/config/constants'
import {
	snackbarContainerTemplate,
	snackbarTemplate,
} from './snackbarTemplates'

export type SnackbarType = 'default' | 'error' | null

const SNACKBAR_CONTAINER_ID = 'snackbar-container'
const SNACKBAR_SHOW_DELAY_MS = 10

class SnackbarController {
	private containerEl: HTMLElement | null = null
	private showTimer: number | undefined
	private removalTimer: number | undefined

	constructor() {
		this.init()
	}
	private init(): void {
		this.containerEl = this.getOrCreateContainer()
	}
	show(
		message: string,
		type: SnackbarType = null,
		durationMs = SNACKBAR_DURATION_MS,
	): void {
		const container = this.getOrCreateContainer()
		if (!container) return

		window.clearTimeout(this.showTimer)
		window.clearTimeout(this.removalTimer)
		container.innerHTML = snackbarTemplate(message, type)

		const snackbarEl = container.lastElementChild
		if (!(snackbarEl instanceof HTMLElement)) return

		this.showElement(snackbarEl)
		this.scheduleRemoval(snackbarEl, durationMs)
	}
	private showElement(snackbarEl: HTMLElement): void {
		this.showTimer = window.setTimeout(() => {
			snackbarEl.classList.add('visible')
		}, SNACKBAR_SHOW_DELAY_MS)
	}

	private scheduleRemoval(snackbarEl: HTMLElement, durationMs: number): void {
		this.removalTimer = window.setTimeout(() => {
			snackbarEl.classList.remove('visible')
			snackbarEl.addEventListener(
				'transitionend',
				() => {
					snackbarEl.remove()
				},
				{ once: true },
			)
		}, durationMs)
	}
	private getOrCreateContainer(): HTMLElement | null {
		const dialogs =
			document.querySelectorAll<HTMLDialogElement>('dialog[open]')
		const host = dialogs[dialogs.length - 1] ?? document.body
		if (this.containerEl?.isConnected) {
			if (this.containerEl.parentElement !== host)
				host.append(this.containerEl)
			return this.containerEl
		}

		this.containerEl = document.getElementById(SNACKBAR_CONTAINER_ID)
		if (this.containerEl) {
			if (this.containerEl.parentElement !== host)
				host.append(this.containerEl)
			return this.containerEl
		}

		host.insertAdjacentHTML(
			'beforeend',
			snackbarContainerTemplate(SNACKBAR_CONTAINER_ID),
		)
		this.containerEl = document.getElementById(SNACKBAR_CONTAINER_ID)
		return this.containerEl
	}
}

let snackbarController: SnackbarController | null = null

export function showSnackbar(
	message: string,
	type: SnackbarType = null,
	durationMs = SNACKBAR_DURATION_MS,
): void {
	getSnackbarController().show(message, type, durationMs)
}

function getSnackbarController(): SnackbarController {
	snackbarController ??= new SnackbarController()
	return snackbarController
}
